import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import { assetPrefix } from 'constants/app';

export const TimelineBox = styled.section`
  padding: 40px;
  border-radius: 12px;
  box-sizing: border-box;
  border: 1px solid ${color.downgray};
  margin-bottom: 80px;

  @media ${device.tablet} {
    margin-bottom: 40px;
  }

  @media ${device.laptop} {
    width: 42%;
    margin-right: 3%;
  }
`;

export const CompanyInfo = styled.section`
  @media ${device.laptop} {
    width: 50%;
  }
`;

export const Timeline = styled.section`
  background: url(${assetPrefix}/images/dot.svg) no-repeat;
  padding-left: 45px;
  min-height: 50px;
  margin-bottom: 30px;
  background-position: 0 20px;
`;

export const TimelineTitle = styled(Text).attrs({
  as: 'p',
  family: 'bold',
})`
  font-size: 18px;
  margin-top: 3px;
  @media ${device.tablet} {
    font-size: 19px;
  }
`;
